import { atom } from "klyva";

// Create the atom with the defined type
export const pricingDialogState = atom<{ isOpen: boolean }>({ isOpen: false });

// Function to open the pricing dialog
export const openPricingDialog = () => {
  pricingDialogState.update(() => ({ isOpen: true }));
};

// Function to close the pricing dialog
export const closePricingDialog = () => {
  pricingDialogState.update(() => ({ isOpen: false }));
};
